import api from './api';

const vettingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVettingStats: builder.query<any, {startDate: string; endDate: string}>({
      query: ({startDate, endDate}) => `vetting/stats?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      providesTags: [{type: 'Vetting', id: 'STATS'}],
    }),
    getVettingConfig: builder.query<any, void>({
      query: () => `vetting/config`,
      providesTags: [{type: 'Vetting', id: 'CONFIG'}],
    }),
    updateVettingConfig: builder.mutation<any, any>({
      query: (config) => ({
        url: `vetting/config`,
        method: 'PUT',
        body: config,
      }),
      invalidatesTags: [
        {type: 'Vetting', id: 'STATS'},
        {type: 'Vetting', id: 'CONFIG'},
      ],
    }),
  }),
});

export const {useGetVettingStatsQuery, useGetVettingConfigQuery, useUpdateVettingConfigMutation} = vettingApi;
